<template>
    <v-row>
        <v-col>
            <div class="subtitle-2">{{ item }}</div>
        </v-col>
        <v-col class="text-right">
            <div class="subtitle-2">{{ value }}</div>
        </v-col>
    </v-row>
</template>
<script>

import Snackbar from "@/components/Snackbar.vue";
import {useVuetify} from "@/composables/vuetify";
import {computed, toRef, ref, toRefs} from "vue";
import MixinIcon from "@/mixins/MixinIcon";

export default {
    name: 'RowItemValue',
    components: {
        Snackbar
    },
    props: {
        item: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: true,
        },
    },
    setup(props, context) {

        const vuetify = useVuetify();
        let isDark = computed(() => {
            return vuetify.theme.dark
        })
        const icons = MixinIcon.data().icons

        // props of item, and green
        const {item, value} = toRefs(props)

        return {
            icons,
            isDark,
            item, value
        }

    }

}

</script>
<style>

.h-60-vh {
    height: 60vh;
}
</style>
